<template>
  <div>
    <RouterView />
    <button v-if="isDev" class="dev-toggle-btn" @click="toggleIsDev">
      {{ isDev ? 'isDev: ON' : 'isDev: OFF' }}
    </button>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { provide, ref, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import cn from '@/locales/cn.json'

export default {
  name: 'App',
  setup() {
    const { t } = useI18n({
      messages: {
        en,
        cn,
      },
    })

    provide('t', t)

    // 前端的 process.env.NODE_ENV：
    // yarn build 時會被設成 production
    // yarn serve 時會被設成 development
    // 吃不到後端的 process.env.NODE_ENV，因此需要另外 fetch 後端的 process.env.NODE_ENV 來更新成 stage

    const isDev = ref(process.env.NODE_ENV === 'development')
    if (isDev.value) isDev.value = false

    // 從 window 對象中讀取 server 端注入的環境變數
    // 如果不存在（例如在開發環境或首次載入），則使用默認值
    const nodeEnv = ref(
      (typeof window !== 'undefined' && window.__SERVER_NODE_ENV__)
        ? window.__SERVER_NODE_ENV__
        : 'development',
    )

    // 如果沒有從 server 端注入（例如開發環境），則嘗試從 /env 獲取
    // 這是一個後備方案，確保在開發環境中也能正常工作
    onBeforeMount(async () => {
      if (isDev.value) return
      if (typeof window !== 'undefined' && window.__SERVER_NODE_ENV__) return

      try {
        const response = await fetch('/env')
        const env = await response.text()
        nodeEnv.value = env
        console.log('App nodeEnv (fallback fetch)', nodeEnv.value)
      } catch (error) {
        console.error('Failed to fetch NODE_ENV from server:', error)
      }
    })

    provide('nodeEnv', nodeEnv)
    provide('isDev', isDev)

    const toggleIsDev = () => {
      isDev.value = !isDev.value
    }

    return {
      t,
      isDev,
      toggleIsDev,
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mukta&family=Open+Sans&family=Lato&family=Roboto');

body {
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Mukta, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'!important;
  margin: 0;
}

code {
  font-size: 12px!important;
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace!important;
  background: #eee;
  padding: 0 4px;
  border-radius: 2px;
  border: 1px solid rgba(38, 50, 56, 0.1);
}

.ant-table-thead > tr > th {
  overflow-wrap: normal!important;
}

.dev-toggle-btn {
  position: fixed;
  left: 8px;
  bottom: 8px;
  z-index: 9999;
  padding: 6px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
